import React from 'react';
import StandardCreditCardPlus from 'components/Offers/StandardCreditCardPlus/StandardCreditCardPlus';
import StandardRedesignCreditCardOfferTwo from 'components/Offers/StandardRedesignCreditCardOfferTwo/StandardRedesignCreditCardOfferTwo';
import { useFlag } from 'hook/flag.hook';
import { isApplyToConfidence } from 'helpers/offer.helpers';

const StandardRedesignMarketplaceCreditCardOfferSwitch = props => {
  const { offerMetadata } = props;
  const sesamePlusPick = offerMetadata?.sesamePlusPick;

  const showAmexWithConfidence = isApplyToConfidence(offerMetadata?.productKey);

  const ocfLargeCreditCardImagesFlag = useFlag('ocf_large_credit_card_images', {
    defaultConfig: {
      large_creditcard_template: false,
    },
    forceDefaultConfigForDisabledOptimizely: true,
  });

  const isLargeCreditCardTemplate =
    ocfLargeCreditCardImagesFlag?.config?.large_creditcard_template;

  if (sesamePlusPick) {
    return <StandardCreditCardPlus {...props} />;
  } else {
    return (
      <StandardRedesignCreditCardOfferTwo
        showAmexWithConfidence={showAmexWithConfidence}
        isLargeCreditCardTemplate={isLargeCreditCardTemplate}
        {...props}
      />
    );
  }
};

export default StandardRedesignMarketplaceCreditCardOfferSwitch;
